import { axios } from '@/utils/request'

/**
 * 供应商列表
 * @param parameter
 * @returns {*}
 */
export function getSupplierList (parameter) {
  return axios({
    url: '/supplier/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改供应商
 * @param parameter
 * @returns {*}
 */
export function editSupplier (parameter) {
  return axios({
    url: '/supplier/edit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增供应商
 * @param parameter
 * @returns {*}
 */
export function addSupplier (parameter) {
  return axios({
    url: '/supplier/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除供应商
 * @param parameter
 * @returns {*}
 */
export function deleteSupplier (parameter) {
  return axios({
    url: '/supplier/delete',
    method: 'post',
    data: parameter
  })
}
